import { render, staticRenderFns } from "./ToubiaoDetail.vue?vue&type=template&id=29495a87&scoped=true&"
import script from "./ToubiaoDetail.vue?vue&type=script&lang=js&"
export * from "./ToubiaoDetail.vue?vue&type=script&lang=js&"
import style0 from "./ToubiaoDetail.vue?vue&type=style&index=0&id=29495a87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29495a87",
  null
  
)

export default component.exports